import * as React from 'react'
import Routes from 'routes'
import { Auth0Provider } from "@auth0/auth0-react"
import { ConfigProvider } from 'antd';
import { ApplicationProvider } from 'context'

import '../../styles/App.scss'

window.React = React

// Color theme config: https://ant.design/docs/react/customize-theme

const App = () => {

  let redirect = `${window.location.origin}/callback`
  
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_KEY}
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: redirect,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE
      }}
    >
    <ApplicationProvider>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: '#24c0ac'
          },
        }}
      >
        <Routes />
      </ConfigProvider>
    </ApplicationProvider>
  </Auth0Provider>
  );
}

export default App;
